<template>
	<div class="content-wrapper">
		<nav aria-label="breadcrumb">
			<ol class="breadcrumb">
				<li class="breadcrumb-item">
					<a href="#">
						<i class="fa fa-home"></i>
						Dashboard
					</a>
				</li>
				<li class="breadcrumb-item">Customer</li>
				<li class="breadcrumb-item active">{{ customer.customer_name }}</li>
				<li class="breadcrumb-right">
					<button v-can="'customers.tds_status'" v-if="customer.tds_status == true"
						class="btn btn-sm btn-danger" @click="tdsStatus()">
						<i class="fa fa-minus"></i>
					</button>
					<button v-can="'customers.tds_status'" v-else class="btn btn-sm btn-success" @click="tdsStatus()">
						<i class="fa fa-plus"></i>
					</button>
					<button v-can="'customers.assign_group'" class="btn btn-sm btn-primary" data-toggle="modal"
						data-target="#add_groups">
						<i class="fa fa-plus"></i>
						Assign Groups
					</button>
					<!-- <button v-can="'customers.credit_limit'" class="btn btn-sm btn-secondary" data-toggle="modal"
						data-target="#credit_limit">
						<i class="fa fa-credit-card"></i>
						Credit Limit
					</button> -->
					<button @click="downloadLedgerExcel" class="btn btn-sm btn-success"
						v-can="'customers.download_ledger'">
						<i class="fa fa-file-excel"></i> Download Ledger
					</button>
					<button v-if="customer.is_affiliate_customer" v-can="'customers.affiliate'"
						class="btn btn-sm btn-info" @click="openAssignCustomersModal">
						<i class="fa fa-user-plus"></i> Assign Customers
					</button>

					<button v-if="!customer.is_affiliate_customer && !customer.affiliate_id"
						v-can="'customers.affiliate'" class="btn btn-sm btn-warning"
						@click="openAssignToAffiliateModal">
						<i class="fa fa-user-tie"></i> Assign to Affiliate
					</button>

					<button v-can="'customers.credit_limit'" class="btn btn-sm btn-secondary" data-toggle="modal"
						data-target="#update_credit_limit" @click="openCreditLimitModal">
						<i class="fa fa-credit-card"></i>
						Update Branch Credit Limit
					</button>
				</li>
			</ol>
		</nav>

		<section class="content">
			<div class="container-fluid">
				<div class="row">
					<div class="col-12">
						<div class="card"
							style="border: none; box-shadow: 0 2px 8px rgba(0,0,0,0.08); border-radius: 10px;">
							<div class="card-header p-0 bg-white border-0" style="border-radius: 10px 10px 0 0;">
								<ul class="nav nav-tabs customer-tabs" role="tablist"
									style="border-bottom: 2px solid #e9ecef; padding: 0 15px; margin-bottom: 0;">
									<li class="nav-item">
										<a class="nav-link customer-tab-link" :class="{ active: activeTab === 'info' }"
											@click.prevent="switchTab('info')" href="#customer-info" role="tab"
											data-toggle="tab">
											<i class="fa fa-user mr-2"></i> Customer Info
										</a>
									</li>
									<li class="nav-item" v-can="'transactions.view'">
										<a class="nav-link customer-tab-link"
											:class="{ active: activeTab === 'transactions' }"
											@click.prevent="switchTab('transactions')" href="#transactions" role="tab"
											data-toggle="tab">
											<i class="fa fa-exchange-alt mr-2"></i> Transactions
										</a>
									</li>
									<li class="nav-item">
										<a class="nav-link customer-tab-link" :class="{ active: activeTab === 'calls' }"
											@click.prevent="switchTab('calls')" href="#calls" role="tab"
											data-toggle="tab">
											<i class="fa fa-phone mr-2"></i> Calls
										</a>
									</li>
								</ul>
							</div>
							<div class="card-body">
								<div class="tab-content">
									<!-- Customer Info Tab -->
									<div class="tab-pane fade" :class="{ 'show active': activeTab === 'info' }"
										id="customer-info" role="tabpanel">
										<!-- Customer Profile Header -->
										<div class="row mb-3">
											<div class="col-12">
												<div class="card customer-profile-header"
													style="background: linear-gradient(135deg, #007bff 0%, #0056b3 100%); border: none; border-radius: 15px; overflow: hidden; box-shadow: 0 10px 30px rgba(0,0,0,0.1);">
													<div class="card-body p-3">
														<div class="row align-items-center">
															<div class="col-auto pr-4">
																<div class="customer-avatar-wrapper"
																	style="position: relative; display: inline-block;">
																	<img :src="customer.avatar" alt="Customer Photo"
																		style="width: 80px; height: 80px; border-radius: 50%; border: 5px solid rgba(255,255,255,0.3); object-fit: cover; box-shadow: 0 5px 15px rgba(0,0,0,0.2); display: block;" />
																	<div v-if="customer.kyc_status == '1'"
																		style="position: absolute; bottom: 5px; right: 5px; width: 32px; height: 32px; background: #28a745; border-radius: 50%; border: 3px solid white; display: flex; align-items: center; justify-content: center; box-shadow: 0 2px 8px rgba(0,0,0,0.2);">
																		<i class="fa fa-check text-white"
																			style="font-size: 11px;"></i>
																	</div>
																</div>
															</div>
															<div class="col">
																<h2 class="text-white mb-3"
																	style="font-weight: 700; font-size: 28px; text-shadow: 0 2px 4px rgba(0,0,0,0.2); line-height: 1.2;">
																	{{ customer.customer_name }}
																</h2>
																<div class="d-flex flex-wrap align-items-center gap-3">
																	<p class="text-white-50 mb-0"
																		style="font-size: 13px; display: flex; align-items: center;">
																		<i class="fa fa-id-card mr-2"
																			style="width: 16px; text-align: center;"></i>
																		<span>{{ customer.customer_no }}</span>
																	</p>
																	<p class="text-white-50 mb-0"
																		style="font-size: 13px; display: flex; align-items: center;">
																		<i class="fa fa-phone mr-2"
																			style="width: 16px; text-align: center;"></i>
																		<span>{{ customer.mobile_no }}</span>
																	</p>
																	<p v-if="customer.email" class="text-white-50 mb-0"
																		style="font-size: 13px; display: flex; align-items: center;">
																		<i class="fa fa-envelope mr-2"
																			style="width: 16px; text-align: center;"></i>
																		<span>{{ customer.email }}</span>
																	</p>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>

										<!-- Customer Details Cards -->
										<div class="row">
											<!-- Basic Information Card -->
											<div class="col-lg-6 mb-3">
												<div class="card h-100 shadow-sm"
													style="border: none; border-radius: 12px; transition: transform 0.2s; height: 100%;">
													<div class="card-header bg-white border-0 pb-1 pt-2 px-2"
														style="border-radius: 12px 12px 0 0;">
														<h5 class="mb-0"
															style="color: #007bff; font-weight: 600; font-size: 14px;">
															<i class="fa fa-info-circle mr-2"></i>Basic Information
														</h5>
													</div>
													<div class="card-body px-2 pt-2 pb-2">
														<div class="info-item mb-3 pb-3 border-bottom"
															style="min-height: 50px;">
															<div
																class="d-flex justify-content-between align-items-start">
																<div class="flex-grow-1" style="min-width: 0;">
																	<small class="text-muted d-block mb-2"
																		style="font-size: 10px; text-transform: uppercase; letter-spacing: 0.5px; font-weight: 600;">Customer
																		Name</small>
																	<span v-if="edit == false"
																		class="font-weight-semibold d-block"
																		style="font-size: 15px; color: #2d3748; word-break: break-word;">
																		{{ customer.customer_name }}
																	</span>
																	<div v-else>
																		<input type="text"
																			v-model="customer.customer_name"
																			:class="{ 'is-invalid': errors.customer_name }"
																			class="form-control form-control-sm"
																			@keyup.enter="updateCustomer" />
																		<span v-if="errors.customer_name"
																			class="invalid-feedback d-block">{{
																				errors.customer_name[0] }}</span>
																	</div>
																</div>
																<div class="ml-3 flex-shrink-0">
																	<a v-if="edit == false"
																		v-can="'customers.mobile_no.update'" href="#"
																		@click.prevent="editCustomer"
																		class="btn btn-sm btn-outline-primary"
																		style="border-radius: 15px; min-width: 32px; padding: 4px 10px; font-size: 12px;">
																		<i class="fa fa-edit"></i>
																	</a>
																	<a v-else href="#" @click.prevent="updateCustomer"
																		class="btn btn-sm btn-success"
																		style="border-radius: 15px; min-width: 32px; padding: 4px 10px; font-size: 12px;">
																		<i class="fa fa-check"></i>
																	</a>
																</div>
															</div>
														</div>
														<div class="info-item mb-3 pb-3 border-bottom"
															style="min-height: 50px;">
															<div
																class="d-flex justify-content-between align-items-start">
																<div class="flex-grow-1" style="min-width: 0;">
																	<small class="text-muted d-block mb-2"
																		style="font-size: 10px; text-transform: uppercase; letter-spacing: 0.5px; font-weight: 600;">Mobile
																		Number</small>
																	<span v-if="edit == false"
																		class="font-weight-semibold d-flex align-items-center"
																		style="font-size: 13px; color: #2d3748;">
																		<i class="fa fa-phone text-primary mr-2"
																			style="width: 16px;"></i>
																		<span>{{ customer.mobile_no }}</span>
																	</span>
																	<div v-else>
																		<input type="number"
																			v-model="customer.mobile_no"
																			:class="{ 'is-invalid': errors.mobile_no }"
																			class="form-control form-control-sm"
																			@keyup.enter="updateCustomer" />
																		<span v-if="errors.mobile_no"
																			class="invalid-feedback d-block">{{
																				errors.mobile_no[0] }}</span>
																	</div>
																</div>
																<div class="ml-3 flex-shrink-0">
																	<a v-if="edit == false"
																		v-can="'customers.mobile_no.update'" href="#"
																		@click.prevent="editCustomer"
																		class="btn btn-sm btn-outline-primary"
																		style="border-radius: 15px; min-width: 32px; padding: 4px 10px; font-size: 12px;">
																		<i class="fa fa-edit"></i>
																	</a>
																	<a v-else href="#" @click.prevent="updateCustomer"
																		class="btn btn-sm btn-success"
																		style="border-radius: 15px; min-width: 32px; padding: 4px 10px; font-size: 12px;">
																		<i class="fa fa-check"></i>
																	</a>
																</div>
															</div>
														</div>
														<div v-if="customer.email"
															class="info-item mb-2 pb-2 border-bottom">
															<small class="text-muted d-block mb-2"
																style="font-size: 10px; text-transform: uppercase; letter-spacing: 0.5px; font-weight: 600;">Email</small>
															<span class="font-weight-semibold d-flex align-items-center"
																style="font-size: 13px; color: #2d3748;">
																<i class="fa fa-envelope text-primary mr-2"
																	style="width: 16px;"></i>
																<span style="word-break: break-word;">{{ customer.email
																}}</span>
															</span>
														</div>
														<div v-if="customer.date_of_birth"
															class="info-item mb-2 pb-2 border-bottom">
															<small class="text-muted d-block mb-2"
																style="font-size: 10px; text-transform: uppercase; letter-spacing: 0.5px; font-weight: 600;">Date
																of Birth</small>
															<span class="font-weight-semibold d-flex align-items-center"
																style="font-size: 13px; color: #2d3748;">
																<i class="fa fa-birthday-cake text-primary mr-2"
																	style="width: 16px;"></i>
																<span>{{ customer.date_of_birth }}</span>
															</span>
														</div>
														<div v-if="customer.city || customer.pincode" class="info-item">
															<small class="text-muted d-block mb-2"
																style="font-size: 10px; text-transform: uppercase; letter-spacing: 0.5px; font-weight: 600;">Address</small>
															<span class="font-weight-semibold d-flex align-items-center"
																style="font-size: 13px; color: #2d3748;">
																<i class="fa fa-map-marker-alt text-primary mr-2"
																	style="width: 18px; flex-shrink: 0;"></i>
																<span style="word-break: break-word;">
																	<span v-if="customer.city">{{ customer.city
																	}}</span>
																	<span v-if="customer.city && customer.pincode">,
																	</span>
																	<span v-if="customer.pincode">{{ customer.pincode
																	}}</span>
																</span>
															</span>
														</div>
													</div>
												</div>
											</div>

											<!-- Documents & KYC Card -->
											<div class="col-lg-6 mb-3">
												<div class="card h-100 shadow-sm"
													style="border: none; border-radius: 12px; height: 100%;">
													<div class="card-header bg-white border-0 pb-1 pt-2 px-2"
														style="border-radius: 12px 12px 0 0;">
														<h5 class="mb-0"
															style="color: #007bff; font-weight: 600; font-size: 14px;">
															<i class="fa fa-file-alt mr-2"></i>Documents & KYC
														</h5>
													</div>
													<div class="card-body px-2 pt-2 pb-2">
														<div v-for="(document, key) in customer?.documents" :key="key"
															class="info-item mb-2 pb-2 border-bottom">
															<small class="text-muted d-block mb-2"
																style="font-size: 10px; text-transform: uppercase; letter-spacing: 0.5px; font-weight: 600;">
																<span v-if="document.document_type == 'pan'">PAN
																	Number</span>
																<span v-if="document.document_type == 'aadhaar'">Aadhaar
																	Number</span>
																<span v-if="document.document_type == 'bank'">Account
																	Number</span>
															</small>
															<span
																class="font-weight-semibold d-flex align-items-center mb-2"
																style="font-size: 13px; color: #2d3748;">
																<i class="fa fa-id-card text-primary mr-2"
																	style="width: 16px;"></i>
																<span style="word-break: break-word;">{{
																	document.document_no_1 }}</span>
															</span>
															<div v-if="document.document_type == 'bank' && document.document_no_2"
																class="mt-2">
																<small class="text-muted d-block mb-2"
																	style="font-size: 10px; text-transform: uppercase; letter-spacing: 0.5px; font-weight: 600;">IFSC
																	Code</small>
																<span class="font-weight-semibold"
																	style="font-size: 13px; color: #2d3748;">{{
																		document.document_no_2 }}</span>
															</div>
															<a v-if="document.document_image"
																:href="document.document_image" target="_blank"
																class="btn btn-sm btn-outline-primary mt-2"
																style="border-radius: 15px; padding: 4px 12px; font-size: 12px;">
																<i class="fa fa-download mr-1"></i>Download
															</a>
														</div>
														<div class="info-item">
															<small class="text-muted d-block mb-2"
																style="font-size: 10px; text-transform: uppercase; letter-spacing: 0.5px; font-weight: 600;">KYC
																Status</small>
															<span v-if="customer.kyc_status == '1'"
																class="badge badge-success badge-lg d-inline-flex align-items-center"
																style="padding: 5px 12px; font-size: 12px; border-radius: 15px;">
																<i class="fa fa-check-circle mr-2"></i>Approved
															</span>
															<span v-else
																class="badge badge-warning badge-lg d-inline-flex align-items-center"
																style="padding: 5px 12px; font-size: 12px; border-radius: 15px;">
																<i class="fa fa-clock mr-2"></i>Pending
															</span>
														</div>
													</div>
												</div>
											</div>

											<!-- Credit Limits Card -->
											<div class="col-lg-6 mb-3">
												<div class="card h-100 shadow-sm"
													style="border: none; border-radius: 12px; height: 100%;">
													<div class="card-header bg-white border-0 pb-1 pt-2 px-2"
														style="border-radius: 12px 12px 0 0;">
														<h5 class="mb-0"
															style="color: #007bff; font-weight: 600; font-size: 14px;">
															<i class="fa fa-credit-card mr-2"></i>Credit Limits
														</h5>
													</div>
													<div class="card-body px-2 pt-2 pb-2">
														<!-- Single Branch Credit Limit -->
														<div v-if="customer?.customer_credit_limit && !can('change_branch')"
															class="info-item">
															<small class="text-muted d-block mb-1"
																style="font-size: 10px; text-transform: uppercase; letter-spacing: 0.5px; font-weight: 600;">Branch
																Credit Limit</small>
															<div class="d-flex align-items-center flex-wrap"
																style="gap: 12px;">
																<h4 class="mb-0"
																	style="color: #007bff; font-weight: 700; font-size: 18px;">
																	{{
																		$formatCurrency(customer.customer_credit_limit.credit_limit
																			|| 0) }}
																</h4>
																<small
																	class="text-muted d-flex align-items-center mb-0">
																	<i class="fa fa-building mr-1"
																		style="width: 16px;"></i>
																	<span>{{
																		customer.customer_credit_limit?.branch?.description
																		||
																		customer.customer_credit_limit?.branch?.branch_name
																		|| 'Current Branch' }}</span>
																</small>
																<small
																	class="text-muted d-flex align-items-center mb-0">
																	<i class="fa fa-user mr-1" style="width: 16px;"></i>
																	<span>Updated by: {{
																		customer.customer_credit_limit?.user?.name ||
																		'N/A' }}</span>
																</small>
															</div>
														</div>
														<!-- Multiple Branch Credit Limits -->
														<template
															v-if="customer?.customer_credit_limits && customer.customer_credit_limits.length > 0 && can('change_branch')">
															<div v-for="(credit_limit, key) in customer.customer_credit_limits"
																:key="key" class="info-item mb-2 pb-2"
																:class="{ 'border-bottom': key < customer.customer_credit_limits.length - 1 }">
																<small class="text-muted d-block mb-1"
																	style="font-size: 10px; text-transform: uppercase; letter-spacing: 0.5px; font-weight: 600;">
																	{{ credit_limit.branch?.description ||
																		credit_limit.branch?.branch_name || 'N/A' }}
																</small>
																<div class="d-flex align-items-center flex-wrap"
																	style="gap: 12px;">
																	<h5 class="mb-0"
																		style="color: #007bff; font-weight: 700; font-size: 16px;">
																		{{ $formatCurrency(credit_limit.credit_limit ||
																			0) }}
																	</h5>
																	<small
																		class="text-muted d-flex align-items-center mb-0">
																		<i class="fa fa-user mr-1"
																			style="width: 16px;"></i>
																		<span>Updated by: {{ credit_limit?.user?.name ||
																			'N/A' }}</span>
																	</small>
																</div>
															</div>
														</template>
														<div v-if="!customer?.customer_credit_limit && (!customer?.customer_credit_limits || customer.customer_credit_limits.length === 0)"
															class="info-item">
															<span class="text-muted">
																<i class="fa fa-info-circle mr-1"></i>No credit limits
																set
															</span>
														</div>
													</div>
												</div>
											</div>

											<!-- Groups & Referral Card -->
											<div class="col-lg-6 mb-3">
												<div class="card h-100 shadow-sm"
													style="border: none; border-radius: 12px; height: 100%;">
													<div class="card-header bg-white border-0 pb-1 pt-2 px-2"
														style="border-radius: 12px 12px 0 0;">
														<h5 class="mb-0"
															style="color: #007bff; font-weight: 600; font-size: 14px;">
															<i class="fa fa-users mr-2"></i>Groups & Referral
														</h5>
													</div>
													<div class="card-body px-2 pt-2 pb-2">
														<div class="info-item mb-3 pb-3 border-bottom">
															<small class="text-muted d-block mb-2"
																style="font-size: 10px; text-transform: uppercase; letter-spacing: 0.5px; font-weight: 600;">Groups</small>
															<div v-if="customer?.customer_groups && customer.customer_groups.length > 0"
																class="d-flex flex-wrap">
																<span class="badge badge-success mr-2 mb-2"
																	v-for="(group, key) in customer.customer_groups"
																	:key="key"
																	style="padding: 5px 10px; font-size: 11px; border-radius: 15px; font-weight: 500; display: inline-flex; align-items: center;">
																	<i class="fa fa-tag mr-1"></i>{{ group?.group?.group
																		|| group?.group || 'N/A' }}
																</span>
															</div>
															<span v-else class="text-muted d-flex align-items-center">
																<i class="fa fa-info-circle mr-2"></i>No groups assigned
															</span>
														</div>
														<div v-if="customer?.referral" class="info-item">
															<small class="text-muted d-block mb-2"
																style="font-size: 10px; text-transform: uppercase; letter-spacing: 0.5px; font-weight: 600;">Referred
																By</small>
															<span
																class="font-weight-semibold d-block mb-3 d-flex align-items-center"
																style="font-size: 13px; color: #2d3748;">
																<i class="fa fa-user-friends text-primary mr-2"
																	style="width: 16px;"></i>
																<span style="word-break: break-word;">{{
																	customer.referral?.customer?.customer_name }}</span>
															</span>
															<small class="text-muted d-block mb-2"
																style="font-size: 10px; text-transform: uppercase; letter-spacing: 0.5px; font-weight: 600;">Referral
																Code</small>
															<span class="font-weight-semibold d-flex align-items-center"
																style="font-size: 13px; color: #2d3748;">
																<i class="fa fa-code text-primary mr-2"
																	style="width: 16px;"></i>
																<span>{{ customer.referral?.referral_code }}</span>
															</span>
														</div>
														<div v-else class="info-item">
															<span class="text-muted d-flex align-items-center">
																<i class="fa fa-info-circle mr-2"></i>No referral
																information
															</span>
														</div>
													</div>
												</div>
											</div>

											<!-- Affiliate Status Card -->
											<div v-can="'customers.affiliate'" class="col-lg-12 mb-3">
												<div class="card shadow-sm" style="border: none; border-radius: 12px;">
													<div class="card-header bg-white border-0 pb-1 pt-2 px-2"
														style="border-radius: 12px 12px 0 0;">
														<h5 class="mb-0"
															style="color: #007bff; font-weight: 600; font-size: 14px;">
															<i class="fa fa-user-tie mr-2"></i>Affiliate Status
														</h5>
													</div>
													<div class="card-body px-2 pt-2 pb-2">
														<div class="row align-items-center">
															<div class="col-md-6">
																<div class="info-item">
																	<small class="text-muted d-block mb-2"
																		style="font-size: 10px; text-transform: uppercase; letter-spacing: 0.5px; font-weight: 600;">Affiliate
																		Status</small>
																	<div
																		class="custom-control custom-switch custom-switch-on-success custom-switch-off-danger">
																		<input type="checkbox"
																			class="custom-control-input"
																			id="affiliate_status"
																			v-model="customer.is_affiliate_customer"
																			@click="toggleAffiliateStatus" />
																		<label class="custom-control-label"
																			for="affiliate_status"
																			style="font-size: 13px; font-weight: 600; padding-top: 2px;">
																			{{ customer.is_affiliate_customer ?
																				'Enabled' : 'Disabled' }}
																		</label>
																	</div>
																</div>
															</div>
															<div v-if="customer.is_affiliate_customer" class="col-md-6">
																<div class="info-item">
																	<small class="text-muted d-block mb-2"
																		style="font-size: 10px; text-transform: uppercase; letter-spacing: 0.5px; font-weight: 600;">Affiliate
																		Credit Limit</small>
																	<div v-if="editAffiliateCreditLimit == false">
																		<h5 class="mb-2"
																			style="color: #007bff; font-weight: 700; font-size: 20px;">
																			{{ customer.affiliate_credit_limit ?
																				$formatCurrency(customer.affiliate_credit_limit)
																				:
																				'Not Set' }}
																		</h5>
																		<a class="btn btn-sm btn-outline-primary"
																			href="#"
																			@click.prevent="editAffiliateCreditLimit = true"
																			style="border-radius: 15px; padding: 4px 12px; font-size: 12px;">
																			<i class="fa fa-edit mr-1"></i>Edit
																		</a>
																	</div>
																	<div v-else>
																		<input type="number" step="0.01"
																			v-model="customer.affiliate_credit_limit"
																			:class="{ 'is-invalid': errors.affiliate_credit_limit }"
																			class="form-control form-control-sm mb-2"
																			@keyup.enter="updateAffiliateCreditLimit" />
																		<span v-if="errors.affiliate_credit_limit"
																			class="invalid-feedback d-block">{{
																				errors.affiliate_credit_limit[0] }}</span>
																		<a class="btn btn-sm btn-success" href="#"
																			@click.prevent="updateAffiliateCreditLimit"
																			style="border-radius: 15px; padding: 4px 12px; font-size: 12px;">
																			<i class="fa fa-check mr-1"></i>Update
																		</a>
																	</div>
																</div>
															</div>
															<div v-if="customer.affiliate_id && customer.affiliate"
																class="col-md-6">
																<div class="info-item">
																	<small class="text-muted d-block mb-2"
																		style="font-size: 10px; text-transform: uppercase; letter-spacing: 0.5px; font-weight: 600;">Assigned
																		to Affiliate</small>
																	<div class="d-flex align-items-center">
																		<div>
																			<h6 class="mb-0"
																				style="color: #007bff; font-weight: 600; font-size: 16px;">
																				{{ customer.affiliate.customer_name }}
																			</h6>
																			<small class="text-muted">
																				{{ customer.affiliate.customer_no }}
																			</small>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>

									<!-- Transactions Tab -->
									<div class="tab-pane fade" :class="{ 'show active': activeTab === 'transactions' }"
										id="transactions" role="tabpanel" v-can="'transactions.view'">
										<div class="card">
											<div class="card-header">
												<h3 class="card-title">Transactions</h3>
												<div class="text-right">
													Global Wallet Balance :

													<div v-if="balance >= 0" style="font-size: 14px;"
														class="badge badge-success badge-lg mr-3">
														{{ balance }}
													</div>
													<div v-else style="font-size: 14px;"
														class="badge badge-danger badge-lg mr-3">
														{{ balance }}
													</div>
													Branch Wallet Balance :
													<div v-if="branch_balance >= 0" style="font-size: 14px;"
														class="badge badge-success badge-lg">
														{{ branch_balance }}
													</div>
													<div v-else style="font-size: 14px;"
														class="badge badge-danger badge-lg">
														{{ branch_balance }}
													</div>
												</div>
											</div>
											<div class="card-body">
												<div class="row">
													<div class="col-sm-4">
														<div class="form-group">
															<label for="from_date">From Date</label>
															<input class="form-control form-control-sm" type="date"
																placeholder="Search" v-model="meta.from_date"
																@change="getTransactions" />
														</div>
													</div>
													<div class="col-sm-4">
														<div class="form-group">
															<label for="from_date">To Date</label>
															<input class="form-control form-control-sm" type="date"
																placeholder="Search" v-model="meta.to_date"
																@change="getTransactions" />
														</div>
													</div>
													<div class="col-sm-4">
														<div class="form-group">
															<label for="from_date">Transaction Type</label>
															<select class="form-control form-control-sm"
																v-model="meta.transaction_type"
																@change="getTransactions">
																<option value="">Select Transaction Type</option>
																<option value="Deposit">Deposit</option>
																<option value="Withdraw">Withdraw</option>
																<option value="TDS">TDS</option>
																<option value="BuyIn">BuyIn</option>
																<option value="CashOut">CashOut</option>
															</select>
														</div>
													</div>
												</div>
												<table
													class="table table-responsive-sm table-bordered table-striped table-sm">
													<thead>
														<tr>
															<th class="text-center">#</th>
															<th>T. No</th>
															<th>T. Date-Time</th>
															<th>T. Type</th>
															<th class="text-right">Amount</th>
															<th class="text-right">Balance</th>
														</tr>
													</thead>
													<tbody>
														<tr v-for="(transaction, key) in transactions" :key="key"
															@click="view_transaction(transaction)">
															<td class="text-center">{{ meta.from + key }}</td>
															<td>{{ transaction.transaction_no }}</td>
															<td>{{ $formatDate(transaction.transaction_date_time,
																'india') }}</td>
															<td>{{ transaction.transaction_type }}</td>
															<td class="text-right">{{ transaction.amount }}</td>
															<td class="text-right">
																{{ calculateLiveBalance(key) }}
															</td>
														</tr>
														<tr v-if="transactions.length <= 0">
															<td colspan="7" style="text-align: center">
																No Records Found
															</td>
														</tr>
													</tbody>
												</table>
											</div>
											<div class="card-footer">
												<div class="float-right">
													<Pagination :maxPage="meta.maxPage" :totalPages="meta.lastPage"
														:currentPage="meta.page" @pagechanged="onPageChange" />
												</div>
											</div>
										</div>
									</div>

									<!-- Calls Tab -->
									<div class="tab-pane fade" :class="{ 'show active': activeTab === 'calls' }"
										id="calls" role="tabpanel" v-if="activeTab === 'calls'">
										<div class="card">
											<div class="card-header">
												<h3 class="card-title">Calls</h3>
											</div>
											<div class="card-body">
												<table
													class="table table-responsive-sm table-bordered table-striped table-sm">
													<thead>
														<tr>
															<th class="text-center">#</th>
															<th>Call Date-Time</th>
															<th>User</th>
															<th>Note</th>
															<th>Reminder Date</th>
														</tr>
													</thead>
													<tbody>
														<tr v-for="(call, key) in calls" :key="key">
															<td class="text-center">{{ key + 1 }}</td>
															<td>{{ call.created_at ? $formatDate(call.created_at,
																'india') : 'N/A' }}</td>
															<td>{{ call.user ? call.user.name : 'N/A' }}</td>
															<td>{{ call.note || 'N/A' }}</td>
															<td>{{ call.reminder_date ? $formatDate(call.reminder_date,
																'india') : 'N/A' }}</td>
														</tr>
														<tr v-if="calls.length <= 0">
															<td colspan="5" style="text-align: center">
																No Calls Found
															</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<div class="modal fade" id="add_groups">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Assign Groups</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="row">
							<div class="col-sm-4" v-for="(group, key) in groups" :key="key">
								<div class="form-check">
									<input class="form-check-input" type="checkbox" :id="group.group_id"
										:value="group.group_id" v-model="customer_groups" />
									<label class="form-check-label" :for="group.group_id">
										{{ group.group }}
									</label>
								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-danger" data-dismiss="modal" ref="CloseGroup">
							<i class="fa fa-times"></i> Close
						</button>
						<button type="button" class="btn btn-success" @click="addGroup()">
							<i class="fas fa-save"></i> Submit
						</button>
					</div>
				</div>
			</div>
		</div>
		<div class="modal fade" id="credit_limit">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Credit Limit</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="row">
							<div class="col-sm-12">
								<div class="form-group">
									<label for="credit_limit">Credit Limit *</label>
									<input type="number" class="form-control form-control-sm"
										:class="{ 'is-invalid': errors.credit_limit }" placeholder="Credit Limit"
										v-model="customer.credit_limit" ref="credit_limit" />
									<span v-if="errors.credit_limit" class="invalid-feedback">{{
										errors.credit_limit[0]
									}}</span>
								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-danger" data-dismiss="modal" ref="Close">
							<i class="fa fa-times"></i> Close
						</button>
						<button type="button" class="btn btn-success" @click="creditLimit()">
							<i class="fa fa-save"></i> Submit
						</button>
					</div>
				</div>
			</div>
		</div>

		<div class="modal fade" id="update_credit_limit">
			<div class="modal-dialog" :class="{ 'modal-lg': can('change_branch') }">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Update Branch Credit Limit</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<!-- Single branch credit limit (for users without change_branch permission) -->
						<div class="row" v-if="!can('change_branch')">
							<div class="col-sm-12">
								<div class="form-group">
									<label for="branch_credit_limit">Branch Credit Limit *</label>
									<input type="number" class="form-control form-control-sm"
										:class="{ 'is-invalid': errors.branch_credit_limit }"
										placeholder="Branch Credit Limit" v-model="branch_credit_limit"
										ref="branch_credit_limit" />
									<span v-if="errors.branch_credit_limit" class="invalid-feedback">{{
										errors.branch_credit_limit[0]
									}}</span>
								</div>
							</div>
						</div>

						<!-- Multiple branch credit limits (for users with change_branch permission) -->
						<div v-if="can('change_branch')">
							<div class="row" v-if="branchCreditLimits.length === 0">
								<div class="col-sm-12">
									<div class="alert alert-info">
										Loading branches...
									</div>
								</div>
							</div>
							<div class="row" v-else>
								<div class="col-sm-12">
									<div class="table-responsive" style="max-height: 400px; overflow-y: auto;">
										<table class="table table-bordered table-sm">
											<thead>
												<tr>
													<th>Branch Name</th>
													<th>Current Credit Limit</th>
													<th>New Credit Limit</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(branchLimit, index) in branchCreditLimits" :key="index">
													<td>{{ branchLimit.branch_name }}</td>
													<td>{{ branchLimit.current_limit || 0 }}</td>
													<td>
														<input type="number" class="form-control form-control-sm"
															:class="{ 'is-invalid': errors['branch_credit_limit_' + branchLimit.branch_id] }"
															v-model="branchLimit.new_limit"
															:placeholder="'Enter credit limit for ' + branchLimit.branch_name" />
														<span
															v-if="errors['branch_credit_limit_' + branchLimit.branch_id]"
															class="invalid-feedback">
															{{ errors['branch_credit_limit_' + branchLimit.branch_id][0]
															}}
														</span>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-danger" data-dismiss="modal" ref="Close">
							<i class="fa fa-times"></i> Close
						</button>
						<button type="button" class="btn btn-success" @click="updateBranchCreditLimit()">
							<i class="fa fa-save"></i> Submit
						</button>
					</div>
				</div>
			</div>
		</div>

		<!-- Assign Customers to Affiliate Modal -->
		<div ref="assignCustomersModal" class="modal fade" tabindex="-1" role="dialog"
			aria-labelledby="assignCustomersModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-xl" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="assignCustomersModalLabel">Assign</h5>
						<button type="button" class="close" @click="closeAssignCustomersModal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="row">
							<div class="col-sm-12">
								<div class="form-group">
									<label>Customer <span class="text-danger">*</span></label>
									<Customer :initialize="selectedCustomerName"
										api-uri="getCustomersForAffiliateAssignment"
										:additional-data="{ affiliate_id: customer.customer_id }"
										@selectCustomer="onCustomerSelect" />
									<span v-if="errors.customer_id" class="text-danger small">{{
										errors.customer_id[0] }}</span>
								</div>
								<div class="form-group">
									<label>Credit Limit</label>
									<input type="number" step="0.01" class="form-control" placeholder="Credit Limit"
										:class="{ 'is-invalid': errors.customer_credit_limit }"
										v-model="affiliateForm.customer_credit_limit" />
									<span v-if="errors.customer_credit_limit" class="invalid-feedback">{{
										errors.customer_credit_limit[0] }}</span>
								</div>
								<div class="form-group">
									<label>Branches <span class="text-danger">*</span></label>
									<div class="border rounded p-3"
										style="max-height: 200px; overflow-y: auto; background-color: #f8f9fa;">
										<div class="row">
											<div class="col-md-4 col-sm-6" v-for="branch in branches"
												:key="branch.branch_id">
												<div class="form-check mb-2">
													<input class="form-check-input" type="checkbox"
														:value="branch.branch_id" :id="'branch_' + branch.branch_id"
														v-model="affiliateForm.branch_ids" />
													<label class="form-check-label" :for="'branch_' + branch.branch_id">
														{{ branch.branch_name || branch.description }}
													</label>
												</div>
											</div>
										</div>
									</div>
									<small class="form-text text-muted">Select one or more branches. The credit limit
										above will
										apply to all selected branches.</small>
									<span v-if="errors.branch_ids" class="text-danger small d-block mt-1">{{
										errors.branch_ids[0] }}</span>
								</div>
							</div>
						</div>
						<hr>
						<div class="row">
							<div class="col-sm-12">
								<div class="d-flex justify-content-between align-items-center mb-3">
									<h6 class="mb-0 font-weight-bold">Customers Under This Affiliate</h6>
									<button type="button" class="btn btn-success" @click="assignCustomer"
										:disabled="!selectedCustomer || !affiliateForm.branch_ids || affiliateForm.branch_ids.length === 0">
										<i class="fas fa-save"></i> Submit
									</button>
								</div>
								<div class="table-responsive">
									<table class="table table-bordered table-striped table-sm mb-0">
										<thead>
											<tr>
												<th class="text-center">#</th>
												<th>Customer No</th>
												<th>Customer Name</th>
												<th>Mobile No</th>
												<th class="text-center">Credit Limit</th>
												<th class="text-center">Action</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(cust, key) in affiliateCustomers" :key="key">
												<td class="text-center">{{ key + 1 }}</td>
												<td>{{ cust.customer_no }}</td>
												<td>{{ cust.customer_name }}</td>
												<td>{{ cust.mobile_no }}</td>
												<td class="text-center">
													<div v-if="editingCreditLimitId !== cust.customer_id">
														<div
															v-if="cust.branch_credit_limits && cust.branch_credit_limits.length > 0">
															<div class="mb-2">
																<span class="font-weight-bold"
																	style="font-size: 14px;">{{
																		$formatCurrency(cust.affiliate_customer_credit_limit
																			|| 0)
																	}}</span>
															</div>
															<div class="text-muted" style="font-size: 11px;">
																<div v-for="(branchLimit, idx) in cust.branch_credit_limits"
																	:key="idx">
																	{{ branchLimit.branch_name }}<span
																		v-if="idx < cust.branch_credit_limits.length - 1">,
																	</span>
																</div>
															</div>
														</div>
														<span v-else>{{
															$formatCurrency(cust.affiliate_customer_credit_limit ||
																0) }}</span>
													</div>
													<div v-else class="text-center">
														<div class="mb-2">
															<input type="number" step="0.01"
																class="form-control form-control-sm mx-auto"
																style="width: 120px;" v-model="editingCreditLimitValue"
																:class="{ 'is-invalid': creditLimitErrors[cust.customer_id] }" />
														</div>
														<div class="border rounded p-2 mb-2 mx-auto"
															style="max-height: 150px; overflow-y: auto; width: 100%; max-width: 300px; background-color: #f8f9fa;">
															<div class="form-check mb-2" v-for="branch in branches"
																:key="branch.branch_id" style="text-align: left;">
																<input class="form-check-input" type="checkbox"
																	:value="branch.branch_id"
																	:id="'edit_branch_' + cust.customer_id + '_' + branch.branch_id"
																	v-model="editingBranchIds"
																	style="margin-top: 0.25rem;" />
																<label class="form-check-label ml-2"
																	style="font-size: 12px; cursor: pointer;"
																	:for="'edit_branch_' + cust.customer_id + '_' + branch.branch_id">
																	{{ branch.branch_name || branch.description }}
																</label>
															</div>
														</div>
														<span v-if="creditLimitErrors[cust.customer_id]"
															class="text-danger small d-block mt-1"
															style="font-size: 11px; max-width: 300px; margin: 0 auto;">{{
																creditLimitErrors[cust.customer_id] }}</span>
													</div>
												</td>
												<td class="text-center">
													<div v-if="editingCreditLimitId !== cust.customer_id">
														<button class="btn btn-xs btn-primary mr-1"
															@click="editCreditLimit(cust)">
															<i class="fa fa-edit"></i> Edit
														</button>
														<button class="btn btn-xs btn-danger"
															@click="deleteAffiliateCustomer(cust)">
															<i class="fa fa-trash"></i> Delete
														</button>
													</div>
													<div v-else>
														<button class="btn btn-xs btn-success mr-1"
															@click="saveCreditLimit(cust)">
															<i class="fa fa-save"></i> Save
														</button>
														<button class="btn btn-xs btn-secondary"
															@click="cancelEditCreditLimit">
															<i class="fa fa-times"></i> Cancel
														</button>
													</div>
												</td>
											</tr>
											<tr v-if="affiliateCustomers.length <= 0">
												<td colspan="6" class="text-center">No customers assigned yet</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-danger" @click="closeAssignCustomersModal">
							<i class="fa fa-times"></i> Close
						</button>
					</div>
				</div>
			</div>
		</div>

		<!-- Assign Customer to Affiliate Modal -->
		<div ref="assignToAffiliateModal" class="modal fade" tabindex="-1" role="dialog"
			aria-labelledby="assignToAffiliateModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-xl" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="assignToAffiliateModalLabel">{{ assignToAffiliateModalTitle }}</h5>
						<button type="button" class="close" @click="closeAssignToAffiliateModal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="row">
							<div class="col-sm-12">
								<div class="form-group">
									<label>Affiliate <span class="text-danger">*</span></label>
									<select class="form-control" v-model="selectedAffiliateId"
										:class="{ 'is-invalid': errors.affiliate_id }">
										<option value="">Select Affiliate</option>
										<option v-for="affiliate in affiliates" :key="affiliate.customer_id"
											:value="affiliate.customer_id">
											{{ affiliate.customer_no }} - {{ affiliate.customer_name }}
										</option>
									</select>
									<span v-if="errors.affiliate_id" class="text-danger small">{{
										errors.affiliate_id[0] }}</span>
								</div>
								<div class="form-group">
									<label>Credit Limit</label>
									<input type="number" step="0.01" class="form-control" placeholder="Credit Limit"
										:class="{ 'is-invalid': errors.customer_credit_limit }"
										v-model="assignToAffiliateForm.customer_credit_limit" />
									<span v-if="errors.customer_credit_limit" class="invalid-feedback">{{
										errors.customer_credit_limit[0] }}</span>
								</div>
								<div class="form-group">
									<label>Branches <span class="text-danger">*</span></label>
									<div class="border rounded p-3"
										style="max-height: 200px; overflow-y: auto; background-color: #f8f9fa;">
										<div class="row">
											<div class="col-md-4 col-sm-6" v-for="branch in branches"
												:key="branch.branch_id">
												<div class="form-check mb-2">
													<input class="form-check-input" type="checkbox"
														:value="branch.branch_id"
														:id="'assign_branch_' + branch.branch_id"
														v-model="assignToAffiliateForm.branch_ids" />
													<label class="form-check-label"
														:for="'assign_branch_' + branch.branch_id">
														{{ branch.branch_name || branch.description }}
													</label>
												</div>
											</div>
										</div>
									</div>
									<small class="form-text text-muted">Select one or more branches. The credit limit
										above will
										apply to all selected branches.</small>
									<span v-if="errors.branch_ids" class="text-danger small d-block mt-1">{{
										errors.branch_ids[0] }}</span>
								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-danger" @click="closeAssignToAffiliateModal">
							<i class="fa fa-times"></i> Close
						</button>
						<button type="button" class="btn btn-success" @click="assignCustomerToAffiliate"
							:disabled="!selectedAffiliateId || !assignToAffiliateForm.branch_ids || assignToAffiliateForm.branch_ids.length === 0">
							<i class="fas fa-save"></i> {{ customer.affiliate_id ? 'Update' : 'Submit' }}
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Pagination from "@/components/Pagination.vue";
import Customer from "@/components/Customer.vue";
import axios from "axios";
export default {
	name: "Proj-Customer.View",
	components: { Pagination, Customer },
	data() {
		return {
			activeTab: 'info',
			edit: false,
			meta: {
				from_date: "",
				to_date: "",
				transaction_type: "",
				status: "Approved",
				customer_id: "",
				order_by: "desc",
				keyword: "transaction_id",
				per_page: 50,
				totalRows: 0,
				page: 1,
				lastPage: 1,
				from: 1,
				maxPage: 1,
				branch_id: this.$store.getters.user.branch_id,
			},
			customer: {},
			balance: 0,
			branch_balance: 0,
			branch_credit_limit: 0,
			branchCreditLimits: [],
			transactions: [],
			customer_groups: [],
			groups: [],
			errors: [],
			calls: [],
			openingBalance: null,
			previousPageBalance: 0,
			editAffiliateCreditLimit: false,
			availableCustomers: [],
			selectedCustomer: null,
			selectedCustomerName: null,
			affiliateCustomers: [],
			affiliateForm: {
				customer_credit_limit: "0",
				branch_ids: [],
			},
			editingCreditLimitId: null,
			editingCreditLimitValue: null,
			editingBranchIds: [],
			creditLimitErrors: {},
			branches: [],
			affiliates: [],
			selectedAffiliateId: null,
			assignToAffiliateForm: {
				customer_credit_limit: "0",
				branch_ids: [],
			},
		};
	},
	computed: {
		assignToAffiliateModalTitle() {
			return this.customer.affiliate_id ? 'Update Customer Affiliate Assignment' : 'Assign Customer to Affiliate';
		}
	},
	beforeRouteEnter(to, from, next) {
		next((vm) => {
			vm.getGroups();
			let uri = {
				uri: "showCustomer",
				data: {
					customer_id: to.params.customer_id,
				},
			};
			vm.$store
				.dispatch("post", uri)
				.then(function (response) {
					vm.customer = response.data.data;
					vm.meta.customer_id = vm.customer.customer_id;
					let selected_groups = response.data.data.customer_groups;
					vm.customer_groups = [];
					selected_groups.forEach((selected_group) => {
						vm.customer_groups.push(selected_group.group_id);
					});
					vm.branch_credit_limit = vm.customer?.customer_credit_limit?.credit_limit || 0;
					vm.prepareBranchCreditLimits();
					vm.getTransactions();
					vm.getCalls();
				})
				.catch(function (error) {
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
		});
	},

	methods: {
		can(permission) {
			let permissions = this.$store.getters.permissions;
			if (permissions && permissions.length != 0) {
				let found = permissions.filter(function (el) {
					return el.ability && el.ability.ability == permission;
				});
				return found[0] ? true : false;
			} else {
				return true;
			}
		},

		switchTab(tab) {
			this.activeTab = tab;
			if (tab === 'calls' && (!this.calls || this.calls.length === 0)) {
				this.getCalls();
			}
		},

		showCustomer() {
			let vm = this;
			let uri = {
				uri: "showCustomer",
				data: {
					customer_id: vm.$route.params.customer_id,
				},
			};
			vm.$store
				.dispatch("post", uri)
				.then(function (response) {
					vm.customer = response.data.data;
					vm.meta.customer_id = vm.customer.customer_id;
					let selected_groups = response.data.data.customer_groups;
					vm.customer_groups = [];
					selected_groups.forEach((selected_group) => {
						vm.customer_groups.push(selected_group.group_id);
					});
					vm.branch_credit_limit = vm.customer?.customer_credit_limit?.credit_limit || 0;
					vm.update_all_branches = false;
				})
				.catch(function (error) {
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
		},
		getGroups() {
			let vm = this;
			vm.$store
				.dispatch("post", { uri: "getGroups" })
				.then(function (response) {
					vm.groups = response.data.data;
				})
				.catch(function (error) {
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
		},

		getTransactions() {
			let vm = this;
			vm.$store
				.dispatch("post", { uri: "paginateTransactions", data: vm.meta })
				.then(function (response) {
					vm.transactions = response.data.data;
					vm.meta.totalRows = response.data.meta.total;
					vm.meta.lastPage = response.data.meta.last_page;
					vm.meta.from = response.data.meta.from;
					vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
					// Calculate page opening balance first, then get wallet
					vm.calculatePageOpeningBalance();
					vm.getCustomerWallet();
				})
				.catch(function (error) {
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
		},

		getCalls() {
			let vm = this;

			vm.$store
				.dispatch("post", {
					uri: "admin/getCustomerCalls",
					data: {
						customer_id: vm.$route.params.customer_id,
					},
				})
				.then(function (response) {
					vm.calls = response.data.data || [];
				})
				.catch(function (error) {
					vm.errors = error.response?.data?.errors || {};
					vm.$store.dispatch("error", error.response?.data?.message || "Failed to load calls");
					vm.calls = [];
				});
		},

		getCustomerWallet() {
			let vm = this;
			vm.$store
				.dispatch("post", {
					uri: "customer/transactions/getCustomerWallet",
					data: this.customer,
				})
				.then(function (response) {
					vm.balance = response.data["global_balance"];
					vm.branch_balance = response.data["branch_balance"];
					// Use branch_balance if branch_id is set, otherwise use global balance
					if (vm.meta.branch_id && vm.meta.branch_id !== '') {
						vm.openingBalance = response.data["branch_balance"];
					} else {
						vm.openingBalance = response.data["opening_balance"];
					}
					// Always recalculate page opening balance after getting wallet balance
					vm.calculatePageOpeningBalance();
				})
				.catch(function (error) {
					vm.errors = error.response.data;
					vm.$store.dispatch("error", error.response.data.message);
				});
		},

		calculatePageOpeningBalance() {
			// Calculate the opening balance for the current page
			// For DESC order: This is the balance AFTER all transactions newer than the current page
			// For ASC order: This is the balance BEFORE the first transaction on the current page

			// Wait for openingBalance to be set if not available yet
			if (this.openingBalance === undefined || this.openingBalance === null) {
				// openingBalance not set yet, will be recalculated when getCustomerWallet completes
				return;
			}

			if (this.meta.order_by === 'desc') {
				// DESC order: newest transactions first
				if (this.meta.page === 1) {
					// First page: balance starts from current balance (opening_balance)
					// We'll work backwards from here
					this.previousPageBalance = this.openingBalance;
				} else {
					// For subsequent pages, calculate balance after all newer pages
					this.calculateBalanceAfterNewerPages();
				}
			} else {
				// ASC order: oldest transactions first
				if (this.meta.page === 1) {
					this.previousPageBalance = 0;
				} else {
					this.calculateBalanceUpToCurrentPage();
				}
			}
		},

		calculateBalanceUpToCurrentPage() {
			// Calculate balance up to the first transaction on the current page
			// by fetching all transactions before the current page
			let vm = this;

			// If we're on page 1, balance starts at 0
			if (vm.meta.page === 1) {
				vm.previousPageBalance = 0;
				return;
			}

			let metaCopy = { ...this.meta };
			metaCopy.page = 1;
			metaCopy.per_page = this.meta.from - 1; // Get all transactions before current page

			if (metaCopy.per_page <= 0) {
				vm.previousPageBalance = 0;
				return;
			}

			vm.$store
				.dispatch("post", { uri: "paginateTransactions", data: metaCopy })
				.then(function (response) {
					let balance = 0; // Start from 0 (opening balance before any transactions)
					const previousTransactions = response.data.data || [];

					previousTransactions.forEach((tx) => {
						const type = tx.transaction_type;
						const amount = parseFloat(tx.amount) || 0;

						if (['Deposit', 'CashOut'].includes(type)) {
							balance += amount;
						} else if (['BuyIn', 'Withdraw', 'TDS'].includes(type)) {
							balance -= amount;
						}
					});

					vm.previousPageBalance = balance;
				})
				.catch(function (error) {
					// If error, fallback to 0
					console.log('Error calculating balance up to current page:', error);
					vm.previousPageBalance = 0;
				});
		},

		creditLimit() {
			let vm = this;
			let loader = vm.$loading.show();
			let uri = { uri: "updateCreditLimit", data: vm.customer };
			vm.$store
				.dispatch("post", uri)
				.then(function () {
					loader.hide();
					vm.$store.dispatch("success", "Credit Limit is successfully changed");
					vm.$refs.Close.click();
				})
				.catch(function (error) {
					loader.hide();
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
		},

		openCreditLimitModal() {
			let vm = this;
			if (vm.can('change_branch')) {
				vm.prepareBranchCreditLimits();
			} else {
				// For users without change_branch permission, just set the current branch credit limit
				vm.branch_credit_limit = vm.customer?.customer_credit_limit?.credit_limit || 0;
			}
		},

		loadBranches() {
			let vm = this;
			vm.$store.dispatch("post", { uri: "getBranches" })
				.then(function (response) {
					let branches = response.data.data || [];
					// Filter out deleted branches
					vm.branches = branches.filter(b => !b.deleted_at);
				})
				.catch(function () {
					vm.$store.dispatch("error", "Error fetching branches");
				});
		},

		prepareBranchCreditLimits() {
			let vm = this;
			vm.branchCreditLimits = [];

			// Fetch all branches
			vm.$store.dispatch("post", { uri: "getBranches" })
				.then(function (response) {
					let branches = response.data.data || [];
					// Filter out deleted branches
					branches = branches.filter(b => !b.deleted_at);

					// Create a map of existing credit limits for quick lookup
					let creditLimitMap = {};
					if (vm.customer?.customer_credit_limits) {
						vm.customer.customer_credit_limits.forEach(creditLimit => {
							creditLimitMap[creditLimit.branch_id] = creditLimit.credit_limit || 0;
						});
					}

					// Prepare branch credit limits array with all branches
					branches.forEach(branch => {
						vm.branchCreditLimits.push({
							branch_id: branch.branch_id,
							branch_name: branch.branch_name || branch.description || 'Unknown Branch',
							current_limit: creditLimitMap[branch.branch_id] || 0,
							new_limit: creditLimitMap[branch.branch_id] || 0
						});
					});
				})
				.catch(function () {
					vm.$store.dispatch("error", "Error fetching branches");
				});
		},

		updateBranchCreditLimit() {
			let vm = this;
			let loader = vm.$loading.show();

			if (vm.can('change_branch') && vm.branchCreditLimits.length > 0) {
				// Filter branches where credit limit has changed
				let branchesToUpdate = vm.branchCreditLimits.filter(branchLimit => {
					// Convert to numbers for comparison
					let currentLimit = parseFloat(branchLimit.current_limit) || 0;
					let newLimit = parseFloat(branchLimit.new_limit) || 0;
					// Only update if value has changed
					return currentLimit !== newLimit;
				});

				if (branchesToUpdate.length === 0) {
					loader.hide();
					vm.$store.dispatch("info", "No changes detected. All credit limits are up to date.");
					vm.$refs.Close.click();
					return;
				}

				// Update only branches where credit limit has changed
				let promises = branchesToUpdate.map(branchLimit => {
					return vm.$store.dispatch("post", {
						uri: "updateCustomerBranchCreditLimit",
						data: {
							customer_id: vm.customer.customer_id,
							credit_limit: branchLimit.new_limit,
							branch_id: branchLimit.branch_id,
							user_id: vm.$store.getters.user.user_id,
						}
					});
				});

				Promise.all(promises).then(function () {
					loader.hide();
					vm.$store.dispatch("success", `Branch Credit Limits are successfully updated for ${branchesToUpdate.length} branch(es)`);
					vm.showCustomer();
					vm.$refs.Close.click();
				}).catch(function (error) {
					loader.hide();
					vm.errors = error.response?.data?.errors || {};
					vm.$store.dispatch("error", error.response?.data?.message || "Error updating branch credit limits");
				});
			} else {
				// Update single branch (current branch) for users without change_branch permission
				let uri = {
					uri: "updateCustomerBranchCreditLimit", data: {
						customer_id: vm.customer.customer_id,
						credit_limit: vm.branch_credit_limit,
						branch_id: vm.$store.getters.user.branch_id,
						user_id: vm.$store.getters.user.user_id,
					}
				};
				vm.$store.dispatch("post", uri).then(function () {
					loader.hide();
					vm.$store.dispatch("success", "Branch Credit Limit is successfully updated");
					vm.showCustomer();
					vm.$refs.Close.click();
				}).catch(function (error) {
					loader.hide();
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
			}
		},

		addGroup() {
			let vm = this;
			let loader = vm.$loading.show();
			vm.customer.groups = vm.customer_groups;
			let uri = { uri: "addCustomerGroup", data: vm.customer };
			vm.$store
				.dispatch("post", uri)
				.then(function (response) {
					loader.hide();
					vm.$store.dispatch(
						"success",
						"Customer Group is successfully updated"
					);
					vm.customer.customer_groups = response.data.data;
					vm.$refs.CloseGroup.click();
				})
				.catch(function (error) {
					loader.hide();
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
		},

		onPageChange(page) {
			this.meta.page = page;
			this.getTransactions();
		},

		discard() {
			let vm = this;
			vm.customer_groups = [];
		},

		editCustomer() {
			let vm = this;
			vm.edit = true;
		},

		updateCustomer() {
			let vm = this;
			let loader = vm.$loading.show();
			let uri = { uri: "updateCustomerMobile", data: vm.customer };
			vm.$store
				.dispatch("post", uri)
				.then(function () {
					loader.hide();
					vm.$store.dispatch(
						"success",
						"Mobile number is successfully updated"
					);
					vm.edit = false;
				})
				.catch(function (error) {
					loader.hide();
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
		},

		tdsStatus() {
			let vm = this;
			let loader = vm.$loading.show();
			let uri = { uri: "tdsStatus", data: vm.customer };
			vm.$store
				.dispatch("post", uri)
				.then(function () {
					loader.hide();
					vm.$store.dispatch("success", "Tds Status is successfully updated");
					vm.edit = false;
					window.location.reload();
				})
				.catch(function (error) {
					loader.hide();
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
		},

		toggleAffiliateStatus() {
			let vm = this;
			vm.customer.is_affiliate_customer = !vm.customer.is_affiliate_customer;
			let loader = vm.$loading.show();
			let data = {
				customer_id: vm.customer.customer_id,
				is_affiliate_customer: vm.customer.is_affiliate_customer,
				affiliate_credit_limit: vm.customer.affiliate_credit_limit || null,
			};
			let uri = { uri: "affiliateStatus", data: data };
			vm.$store
				.dispatch("post", uri)
				.then(function () {
					loader.hide();
					vm.$store.dispatch(
						"success",
						"Affiliate Status is successfully updated"
					);
				})
				.catch(function (error) {
					loader.hide();
					vm.customer.is_affiliate_customer = !vm.customer.is_affiliate_customer;
					vm.errors = error.response?.data?.errors || {};
					vm.$store.dispatch("error", error.response?.data?.message || "Failed to update affiliate status");
				});
		},

		updateAffiliateCreditLimit() {
			let vm = this;
			let loader = vm.$loading.show();
			let data = {
				customer_id: vm.customer.customer_id,
				affiliate_credit_limit: vm.customer.affiliate_credit_limit || null,
			};
			let uri = { uri: "affiliateStatus", data: data };
			vm.$store
				.dispatch("post", uri)
				.then(function () {
					loader.hide();
					vm.$store.dispatch(
						"success",
						"Affiliate Credit Limit is successfully updated"
					);
					vm.editAffiliateCreditLimit = false;
				})
				.catch(function (error) {
					loader.hide();
					vm.errors = error.response?.data?.errors || {};
					vm.$store.dispatch("error", error.response?.data?.message || "Failed to update affiliate credit limit");
				});
		},

		formatTransactionAmount(transaction) {
			// Display all amounts as positive values
			const amount = parseFloat(transaction.amount) || 0;
			return Math.abs(amount).toFixed(2);
		},

		downloadLedgerExcel() {
			let vm = this;
			let loader = vm.$loading.show();

			// Prepare data with display_type for Excel export
			const exportData = {
				...vm.meta,
				display_type: 'excel'
			};

			// Use axios directly for blob download
			axios
				.post(vm.$store.getters.apiUrl + 'paginateTransactions', exportData, {
					headers: {
						Authorization: "Bearer" + " " + vm.$store.getters.token,
					},
					responseType: 'blob' // Important for file downloads
				})
				.then(function (response) {
					loader.hide();
					// Create blob from response
					const blob = new Blob([response.data], {
						type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
					});

					// Create download link
					const url = window.URL.createObjectURL(blob);
					const link = document.createElement('a');
					link.href = url;

					// Generate filename with customer name and date
					const customerName = vm.customer.customer_name || 'Customer';
					const dateStr = new Date().toISOString().split('T')[0];
					link.download = `${customerName}_Ledger_${dateStr}.xlsx`;

					// Trigger download
					document.body.appendChild(link);
					link.click();

					// Cleanup
					document.body.removeChild(link);
					window.URL.revokeObjectURL(url);

					vm.$store.dispatch("success", "Ledger downloaded successfully");
				})
				.catch(function (error) {
					loader.hide();
					vm.$store.dispatch("error", error.response?.data?.message || "Failed to download ledger");
				});
		},

		calculateLiveBalance(index) {
			// Start from the balance after previous pages
			let balance = this.previousPageBalance !== undefined && this.previousPageBalance !== null
				? this.previousPageBalance
				: 0;

			// Ensure transactions array exists and index is within bounds
			if (!this.transactions || !Array.isArray(this.transactions) || this.transactions.length === 0) {
				return balance.toFixed(2);
			}

			if (index < 0 || index >= this.transactions.length) {
				return balance.toFixed(2);
			}

			if (this.meta.order_by === 'desc') {
				// DESC order: work backwards from current balance
				// Balance shows the balance AFTER the transaction at this row
				// For row at index, balance = previousPageBalance - sum of transactions[0] to [index-1]
				// Process transactions from 0 to index-1 (reverse effects of transactions before current row)
				for (let i = 0; i < index && i < this.transactions.length; i++) {
					const tx = this.transactions[i];
					if (!tx) continue;

					const type = tx.transaction_type;
					const amount = parseFloat(tx.amount) || 0;

					// Reverse the transaction effect (going backwards in time)
					if (['Deposit', 'CashOut'].includes(type)) {
						balance -= amount; // Reverse: subtract what was added
					} else if (['BuyIn', 'Withdraw', 'TDS'].includes(type)) {
						balance += amount; // Reverse: add back what was subtracted
					}
				}
			} else {
				// ASC order: work forwards from opening balance
				// Process all transactions from 0 to index (inclusive) - this includes the last row
				for (let i = 0; i <= index && i < this.transactions.length; i++) {
					const tx = this.transactions[i];
					if (!tx) continue;

					const type = tx.transaction_type;
					const amount = parseFloat(tx.amount) || 0;

					if (['Deposit', 'CashOut'].includes(type)) {
						balance += amount;
					} else if (['BuyIn', 'Withdraw', 'TDS'].includes(type)) {
						balance -= amount;
					}
				}
			}

			return balance.toFixed(2);
		},

		calculateBalanceAfterNewerPages() {
			// For DESC order: Calculate balance after all transactions newer than current page
			// This means we need to get all transactions from page 1 to (current page - 1)
			let vm = this;

			// Ensure openingBalance is set
			if (vm.openingBalance === undefined || vm.openingBalance === null) {
				return;
			}

			if (vm.meta.page === 1) {
				vm.previousPageBalance = vm.openingBalance;
				return;
			}

			// Get all transactions from newer pages (page 1 to current page - 1)
			let metaCopy = { ...this.meta };
			metaCopy.page = 1;
			metaCopy.per_page = (this.meta.page - 1) * this.meta.per_page; // Total transactions from newer pages

			if (metaCopy.per_page <= 0) {
				vm.previousPageBalance = vm.openingBalance;
				return;
			}

			vm.$store
				.dispatch("post", { uri: "paginateTransactions", data: metaCopy })
				.then(function (response) {
					// Start from current balance and reverse all newer transactions
					let balance = vm.openingBalance;
					const newerTransactions = response.data.data || [];

					newerTransactions.forEach((tx) => {
						const type = tx.transaction_type;
						const amount = parseFloat(tx.amount) || 0;

						// Reverse the transaction effect (going backwards in time)
						if (['Deposit', 'CashOut'].includes(type)) {
							balance -= amount;
						} else if (['BuyIn', 'Withdraw', 'TDS'].includes(type)) {
							balance += amount;
						}
					});

					vm.previousPageBalance = balance;
				})
				.catch(function (error) {
					console.log('Error calculating balance after newer pages:', error);
					vm.previousPageBalance = vm.openingBalance;
				});
		},

		openAssignCustomersModal() {
			let vm = this;
			vm.selectedCustomer = null;
			vm.selectedCustomerName = null;
			vm.affiliateForm.customer_credit_limit = "0";
			vm.affiliateForm.branch_ids = [];
			vm.errors = [];
			vm.loadBranches();
			vm.loadAffiliateCustomers();

			// Show modal using ref
			if (vm.$refs.assignCustomersModal) {
				const modalElement = vm.$refs.assignCustomersModal;
				modalElement.classList.add('show');
				modalElement.style.display = 'block';
				modalElement.setAttribute('aria-hidden', 'false');
				document.body.classList.add('modal-open');
				// Add backdrop
				const backdrop = document.createElement('div');
				backdrop.className = 'modal-backdrop fade show';
				backdrop.setAttribute('id', 'assignCustomersModalBackdrop');
				document.body.appendChild(backdrop);
			}
		},

		closeAssignCustomersModal() {
			let vm = this;
			if (vm.$refs.assignCustomersModal) {
				const modalElement = vm.$refs.assignCustomersModal;
				modalElement.classList.remove('show');
				modalElement.style.display = 'none';
				modalElement.setAttribute('aria-hidden', 'true');
				document.body.classList.remove('modal-open');
				// Remove backdrop
				const backdrop = document.getElementById('assignCustomersModalBackdrop');
				if (backdrop) {
					backdrop.remove();
				}
			}
			// Reset form when closing modal
			vm.selectedCustomer = null;
			vm.selectedCustomerName = null;
			vm.affiliateForm.customer_credit_limit = "0";
			vm.affiliateForm.branch_ids = [];
			vm.affiliateCustomers = [];
			vm.errors = [];
			vm.editingCreditLimitId = null;
			vm.editingCreditLimitValue = null;
			vm.editingBranchIds = [];
			vm.creditLimitErrors = {};
		},

		loadAffiliateCustomers() {
			let vm = this;
			if (!vm.customer.customer_id || !vm.customer.is_affiliate_customer) {
				return;
			}

			vm.$store
				.dispatch("post", {
					uri: "getAffiliateCustomers",
					data: {
						affiliate_id: vm.customer.customer_id
					}
				})
				.then(function (response) {
					vm.affiliateCustomers = response.data.data || [];
				})
				.catch(function (error) {
					vm.errors = error.response?.data?.errors || {};
					vm.$store.dispatch("error", error.response?.data?.message || "Failed to load affiliate customers");
				});
		},

		onCustomerSelect(event) {
			let vm = this;
			vm.selectedCustomer = event.target.value;
			if (vm.selectedCustomer) {
				vm.selectedCustomerName = vm.selectedCustomer.customer_no + ' - ' + vm.selectedCustomer.customer_name;
			}
		},

		assignCustomer() {
			let vm = this;
			if (!vm.selectedCustomer) {
				vm.$store.dispatch("error", "Please select a customer");
				return;
			}
			if (!vm.affiliateForm.branch_ids || vm.affiliateForm.branch_ids.length === 0) {
				vm.$store.dispatch("error", "Please select at least one branch");
				return;
			}

			let loader = vm.$loading.show();
			let data = {
				customer_id: vm.selectedCustomer.customer_id,
				affiliate_id: vm.customer.customer_id,
				customer_credit_limit: vm.affiliateForm.customer_credit_limit || "0",
				branch_ids: vm.affiliateForm.branch_ids,
			};

			vm.$store
				.dispatch("post", { uri: "assignCustomerToAffiliate", data: data })
				.then(function () {
					loader.hide();
					vm.$store.dispatch("success", "Customer successfully assigned to affiliate");
					vm.selectedCustomer = null;
					vm.selectedCustomerName = null;
					vm.affiliateForm.customer_credit_limit = "0";
					vm.affiliateForm.branch_ids = [];
					vm.errors = {};
					// Reload affiliate customers list
					vm.loadAffiliateCustomers();
				})
				.catch(function (error) {
					loader.hide();
					vm.errors = error.response?.data?.errors || {};
					vm.$store.dispatch("error", error.response?.data?.message || "Failed to assign customer to affiliate");
				});
		},

		deleteAffiliateCustomer(customer) {
			let vm = this;
			if (!confirm('Are you sure you want to remove this customer from the affiliate?')) {
				return;
			}

			let loader = vm.$loading.show();
			let data = {
				customer_id: customer.customer_id,
				affiliate_id: vm.customer.customer_id,
			};

			vm.$store
				.dispatch("post", { uri: "deleteAffiliateCustomer", data: data })
				.then(function () {
					loader.hide();
					vm.$store.dispatch("success", "Customer successfully removed from affiliate");
					// Reload affiliate customers list
					vm.loadAffiliateCustomers();
				})
				.catch(function (error) {
					loader.hide();
					vm.errors = error.response?.data?.errors || {};
					vm.$store.dispatch("error", error.response?.data?.message || "Failed to remove customer from affiliate");
				});
		},

		editCreditLimit(customer) {
			let vm = this;
			vm.editingCreditLimitId = customer.customer_id;
			vm.editingCreditLimitValue = customer.affiliate_customer_credit_limit || 0;

			// Ensure branches are loaded
			if (!vm.branches || vm.branches.length === 0) {
				vm.loadBranches();
			}

			// Load existing branch IDs if available
			if (customer.branch_credit_limits && Array.isArray(customer.branch_credit_limits) && customer.branch_credit_limits.length > 0) {
				vm.editingBranchIds = customer.branch_credit_limits.map(b => b.branch_id).filter(id => id != null);
			} else {
				vm.editingBranchIds = [];
			}

			vm.creditLimitErrors = {};
		},

		cancelEditCreditLimit() {
			let vm = this;
			vm.editingCreditLimitId = null;
			vm.editingCreditLimitValue = null;
			vm.editingBranchIds = [];
			vm.creditLimitErrors = {};
		},

		saveCreditLimit(customer) {
			let vm = this;
			if (vm.editingCreditLimitValue === null || vm.editingCreditLimitValue === undefined || vm.editingCreditLimitValue < 0) {
				vm.creditLimitErrors[customer.customer_id] = "Credit limit must be a valid number greater than or equal to 0";
				return;
			}
			if (!vm.editingBranchIds || vm.editingBranchIds.length === 0) {
				vm.creditLimitErrors[customer.customer_id] = "Please select at least one branch";
				return;
			}

			let loader = vm.$loading.show();
			let data = {
				customer_id: customer.customer_id,
				affiliate_id: vm.customer.customer_id,
				customer_credit_limit: vm.editingCreditLimitValue,
				branch_ids: vm.editingBranchIds,
			};

			vm.$store
				.dispatch("post", { uri: "updateAffiliateCustomerCreditLimit", data: data })
				.then(function () {
					loader.hide();
					vm.$store.dispatch("success", "Credit limit successfully updated");
					vm.editingCreditLimitId = null;
					vm.editingCreditLimitValue = null;
					vm.editingBranchIds = [];
					vm.creditLimitErrors = {};
					// Reload affiliate customers list
					vm.loadAffiliateCustomers();
				})
				.catch(function (error) {
					loader.hide();
					if (error.response?.data?.errors?.customer_credit_limit) {
						const errorMessage = error.response.data.errors.customer_credit_limit[0];
						vm.creditLimitErrors[customer.customer_id] = errorMessage;
						// Also show alert message
						vm.$store.dispatch("error", error.response?.data?.message || errorMessage);
					} else {
						vm.$store.dispatch("error", error.response?.data?.message || "Failed to update credit limit");
					}
				});
		},

		openAssignToAffiliateModal() {
			let vm = this;
			vm.selectedAffiliateId = null;
			vm.assignToAffiliateForm.customer_credit_limit = "0";
			vm.assignToAffiliateForm.branch_ids = [];
			vm.errors = [];

			// Load branches and affiliates first, then load existing assignment
			Promise.all([
				vm.$store.dispatch("post", { uri: "getBranches" }).then(function (response) {
					let branches = response.data.data || [];
					vm.branches = branches.filter(b => !b.deleted_at);
				}),
				vm.$store.dispatch("post", { uri: "getAffiliates" }).then(function (response) {
					vm.affiliates = response.data.data || [];
				})
			]).then(function () {
				// Always try to load existing assignment (check affiliate_customers table)
				return vm.$store.dispatch("post", {
					uri: "getCustomerAffiliateAssignment",
					data: {
						customer_id: vm.customer.customer_id
					}
				}).then(function (response) {
					console.log('Full affiliate assignment response:', JSON.stringify(response, null, 2));
					if (response && response.data) {
						// Check both possible response structures
						const assignment = response.data.data || response.data;
						console.log('Assignment data:', assignment);

						if (assignment && assignment.affiliate_id) {
							vm.$nextTick(function () {
								vm.selectedAffiliateId = assignment.affiliate_id;
								vm.assignToAffiliateForm.customer_credit_limit = String(assignment.customer_credit_limit || "0");
								// Convert branch_ids to numbers for checkbox binding
								vm.assignToAffiliateForm.branch_ids = (assignment.branch_ids || []).map(id => Number(id));
								console.log('Set values - affiliate_id:', vm.selectedAffiliateId, 'credit_limit:', vm.assignToAffiliateForm.customer_credit_limit, 'branch_ids:', vm.assignToAffiliateForm.branch_ids);
								console.log('Current form state:', vm.assignToAffiliateForm);
							});
						} else {
							console.log('No assignment data found or invalid structure:', assignment);
						}
					} else {
						console.log('No data in response:', response);
					}
				}).catch(function (error) {
					console.log('Error loading affiliate assignment:', error);
					console.log('Error response:', error.response);
					// Don't show error if customer is simply not assigned (404 or null response is OK)
					if (error.response && error.response.status !== 404) {
						vm.$store.dispatch("error", error.response?.data?.message || "Failed to load affiliate assignment");
					}
				});
			}).catch(function (error) {
				console.log('Error loading branches or affiliates:', error);
				vm.$store.dispatch("error", "Failed to load branches or affiliates");
			}).finally(function () {
				// Show modal after data is loaded
				if (vm.$refs.assignToAffiliateModal) {
					const modalElement = vm.$refs.assignToAffiliateModal;
					modalElement.classList.add('show');
					modalElement.style.display = 'block';
					modalElement.setAttribute('aria-hidden', 'false');
					document.body.classList.add('modal-open');
					// Add backdrop
					const backdrop = document.createElement('div');
					backdrop.className = 'modal-backdrop fade show';
					backdrop.setAttribute('id', 'assignToAffiliateModalBackdrop');
					document.body.appendChild(backdrop);
				}
			});
		},

		closeAssignToAffiliateModal() {
			let vm = this;
			if (vm.$refs.assignToAffiliateModal) {
				const modalElement = vm.$refs.assignToAffiliateModal;
				modalElement.classList.remove('show');
				modalElement.style.display = 'none';
				modalElement.setAttribute('aria-hidden', 'true');
				document.body.classList.remove('modal-open');
				// Remove backdrop
				const backdrop = document.getElementById('assignToAffiliateModalBackdrop');
				if (backdrop) {
					backdrop.remove();
				}
			}
			// Reset form when closing modal
			vm.selectedAffiliateId = null;
			vm.assignToAffiliateForm.customer_credit_limit = "0";
			vm.assignToAffiliateForm.branch_ids = [];
			vm.errors = [];
		},

		loadAffiliates() {
			let vm = this;
			vm.$store
				.dispatch("post", { uri: "getAffiliates" })
				.then(function (response) {
					vm.affiliates = response.data.data || [];
				})
				.catch(function (error) {
					vm.errors = error.response?.data?.errors || {};
					vm.$store.dispatch("error", error.response?.data?.message || "Failed to load affiliates");
				});
		},

		assignCustomerToAffiliate() {
			let vm = this;
			if (!vm.selectedAffiliateId) {
				vm.$store.dispatch("error", "Please select an affiliate");
				return;
			}
			if (!vm.assignToAffiliateForm.branch_ids || vm.assignToAffiliateForm.branch_ids.length === 0) {
				vm.$store.dispatch("error", "Please select at least one branch");
				return;
			}

			let loader = vm.$loading.show();
			let data = {
				customer_id: vm.customer.customer_id,
				affiliate_id: vm.selectedAffiliateId,
				customer_credit_limit: vm.assignToAffiliateForm.customer_credit_limit || "0",
				branch_ids: vm.assignToAffiliateForm.branch_ids,
			};

			vm.$store
				.dispatch("post", { uri: "assignCustomerToAffiliate", data: data })
				.then(function () {
					loader.hide();
					vm.$store.dispatch("success", "Customer successfully assigned to affiliate");
					vm.closeAssignToAffiliateModal();
					// Reload customer data to reflect the change
					vm.showCustomer();
				})
				.catch(function (error) {
					loader.hide();
					vm.errors = error.response?.data?.errors || {};
					vm.$store.dispatch("error", error.response?.data?.message || "Failed to assign customer to affiliate");
				});
		},
	},
};
</script>

<style scoped>
.customer-tabs {
	border-bottom: 2px solid #e9ecef;
	padding: 0 15px;
	margin-bottom: 0;
}

.customer-tab-link {
	border: none !important;
	border-bottom: 3px solid transparent !important;
	padding: 12px 20px !important;
	margin-right: 5px !important;
	color: #6c757d !important;
	font-weight: 500 !important;
	font-size: 14px !important;
	transition: all 0.3s ease !important;
	position: relative !important;
	border-radius: 0 !important;
	background-color: transparent !important;
}

.customer-tab-link:hover {
	color: #007bff !important;
	background-color: rgba(0, 123, 255, 0.05) !important;
	border-bottom-color: rgba(0, 123, 255, 0.3) !important;
}

.customer-tab-link.active {
	color: #007bff !important;
	border-bottom-color: #007bff !important;
	background-color: transparent !important;
	font-weight: 600 !important;
}

.customer-tab-link.active:hover {
	border-bottom-color: #007bff !important;
	background-color: rgba(0, 123, 255, 0.05) !important;
}

.customer-tab-link i {
	font-size: 14px;
	width: 18px;
	text-align: center;
}

.customer-tabs .nav-item {
	margin-bottom: -2px;
}
</style>
